// extracted by mini-css-extract-plugin
module.exports = {"userMenuMenuItem":"UserMenu_userMenuMenuItem__leRu7","userMenuPopover":"UserMenu_userMenuPopover__1J2E6"};